<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    titleTemplate: '%s',
    htmlAttrs: { lang: 'en' },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.5, user-scalable=1, shrink-to-fit=no' },
      // Default fallback meta — individual pages override these via their own metaInfo
      { name: 'description', content: 'Beastmode Cleanup offers professional residential and commercial cleaning services. Home cleaning, AirBnB turnovers, and recreational vehicle cleaning.' },
      { name: 'robots', content: 'index, follow' },
      // Twitter Card
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Beastmode Cleanup | Professional Cleaning Services' },
      { name: 'twitter:description', content: 'Professional residential and commercial cleaning services. Home cleaning, AirBnB turnovers, and recreational vehicle cleaning.' },
      { name: 'twitter:image', content: 'https://www.beastmodecleanup.com/api/beastmodeimgs/white_claw_beast.JPG' },
      // Open Graph
      { property: 'og:title', content: 'Beastmode Cleanup | Professional Cleaning Services' },
      { property: 'og:description', content: 'Professional residential and commercial cleaning services. Home cleaning, AirBnB turnovers, and recreational vehicle cleaning.' },
      { property: 'og:image', content: 'https://www.beastmodecleanup.com/api/beastmodeimgs/white_claw_beast.JPG' },
      { property: 'og:url', content: 'https://www.beastmodecleanup.com' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'Beastmode Cleanup' },
      { property: 'og:locale', content: 'en_US' },
    ],
  },
  data() {
    return {
      isDarkTheme: window.matchMedia('(prefers-color-scheme: dark)').matches
    }
  },
  watch: {
    isDarkTheme() {
      this.setFavicon()
    }
  },
  mounted() {
    this.setFavicon()
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      this.isDarkTheme = e.matches
    })
  },
  methods: {
    setFavicon() {
      // Switch between dark/light logo based on OS color scheme preference
      // Uses the 192px PNG for the dynamic swap (the .ico is always loaded first by the browser)
      const favicon = document.querySelector('link[rel="icon"][type="image/png"][sizes="192x192"]')
      if (favicon) {
        const basePath = this.isDarkTheme ? 'dark_beastmode.png' : 'light_beastmode.png'
        favicon.href = `${process.env.BASE_URL}${basePath}?t=${Date.now()}`
      }
    }
  }
}
</script>
